

export const api_url ={
  api: {
    url: process.env.REACT_APP_API_URL,
    AUTH: process.env.REACT_APP_AUTH,
  },
};